<!-- 留言管理 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('联系人电话')">
              <j-input :placeholder="$t('请输入联系人电话')" v-model="queryParam.userPhone"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('状态')">
              <a-select v-model="queryParam.complaintsState" :placeholder="$t('请选择状态')">
                <a-select-option :value="0">{{ $t('未处理') }}</a-select-option>
                <a-select-option :value="1">{{ $t('已处理') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('留言类型')">
              <a-select v-model="queryParam.complaintsType" :placeholder="$t('请选择留言类型')">
                <a-select-option value="0">{{ $t('咨询') }}</a-select-option>
                <a-select-option value="1">{{ $t('建议') }}</a-select-option>
                <a-select-option value="2">{{ $t('投诉') }}</a-select-option>
                <a-select-option value="3">{{ $t('其他') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!-- <a-button type="primary" @click="handleAdd" icon="plus" style="margin-left: 8px">新建留言</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="complaintsState" slot-scope="text,record">
          <a-tag color="#108ee9" v-if="record.complaintsState==0">{{ $t('处理中') }}</a-tag>
          <a-tag color="#87d068" v-if="record.complaintsState==1">{{ $t('等待评价') }}</a-tag>
          <a-tag color="#f50" v-if="record.complaintsState==2">{{ $t('结束') }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
  </div>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from '@/views/OAoffice/complaintManagement/modal.vue'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'MessageInformation',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      JInput
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/oa/userComplaints/list",
        },
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },

          {
            title: this.$t('留言类型'),
            align:"center",
            dataIndex: 'complaintsType',
            customRender:(t)=>{
              if(t!=null){
                return [this.$t('咨询'),this.$t('建议'),this.$t('投诉'),this.$t('其他')][t]
              }else{
                return this.$t('其他')
              }
            },
            width:100,
            ellipsis: true,
          },
          {
            title: this.$t('联系人名称'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('联系人电话'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('精确地址'),
            align:"center",
            dataIndex: 'userAddress',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('情况描述'),
            align:"center",
            dataIndex: 'complaintsDetail',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('状态'),
            align:"center",
            dataIndex: 'complaintsState',
            scopedSlots: { customRender: 'complaintsState' },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('处理人'),
            align:"center",
            dataIndex: 'complaintsProcessors',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'complaintsTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('来源'),
            align:"center",
            dataIndex: 'complaintsSource',
            customRender:(t)=>{
              if(t==0){
                return this.$t('公众号')
              }else if(t==1){
                return this.$t('客服热线')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail');
        });
      },
      handleAdd(){
        this.$nextTick(()=>{
          this.$refs.modalForm.init({},'add');
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>